// extracted by mini-css-extract-plugin
var _1 = "TextareaElement-moduleborderless__AQ_nR";
var _2 = "TextareaElement-moduledisabled__l70Jj";
var _3 = "TextareaElement-moduledisabledOverlay__NleiW";
var _4 = "TextareaElement-moduleerror__tJbaK";
var _5 = "TextareaElement-modulefocusHider__uo82h";
var _6 = "TextareaElement-modulefocused__g9iMv";
var _7 = "TextareaElement-modulehidePlaceholderOnFocus__Ww4A3";
var _8 = "TextareaElement-moduletextarea__qU85k";
var _9 = "TextareaElement-moduletextareaBox__Fogeu";
var _a = "TextareaElement-moduletextareaPullIcon__hsLTX IconNG-moduleiconContainer__SxWZ0";
var _b = "TextareaElement-modulewithoutManualResize__nL6yt";
export { _1 as "borderless", _2 as "disabled", _3 as "disabledOverlay", _4 as "error", _5 as "focusHider", _6 as "focused", _7 as "hidePlaceholderOnFocus", _8 as "textarea", _9 as "textareaBox", _a as "textareaPullIcon", _b as "withoutManualResize" }
